angular.module('TetherApp').factory('broadcastService', [
    '$http',
    function ($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getBroadcast = function (type, page) {
            let uri = '/api/v1/broadcast/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );

            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' },
                params: { type: type, page: page }
            }).then(function (response) {
                return response.data;
            });
        };

        let getUsersLists = function () {
            let uri = '/api/v1/users/lists/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getExperienceList = function () {
            let uri = '/api/v1/experiences/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getSubscriptionList = function () {
            let uri = '/api/v1/subscriptions/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipants = function (broadcastId) {
            let uri = '/api/v1/broadcast/' + broadcastId + '/participants/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let sendBroadcast = function (broadcast) {
            return $http.post(
                '/message-user',
                broadcast,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let cancelBroadcast = function (listId) {
            let uri = '/api/v1/broadcast/' + listId + '/cancel/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let editBroadcast = function (broadcastId, listId, campaignId, shortcodeId, title, message, sendAfter, experienceId, message_fr) {
            let uri = '/api/v1/broadcast/' + broadcastId + '/edit/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.put(
                uri,
                {
                    participant_list_id: listId,
                    campaign_id: campaignId,
                    shortcode_id: shortcodeId,
                    title: title,
                    message: message,
                    message_fr: message_fr,
                    send_after: sendAfter,
                    experience_id : experienceId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getBroadcast: getBroadcast,
            getUsersLists: getUsersLists,
            getExperienceList: getExperienceList,
            getSubscriptionList: getSubscriptionList,
            sendBroadcast: sendBroadcast,
            cancelBroadcast: cancelBroadcast,
            editBroadcast: editBroadcast,
            getParticipants: getParticipants
        }

    }
]);
